import { ENVIRONMENT } from "@/config/config";
import { combineReducers, configureStore } from "@reduxjs/toolkit";

import { persistReducer, persistStore } from "redux-persist";
import thunk from "redux-thunk";
import counterReducer from "@/features/counter/counterSlice";
import errorReducer from "@/features/error/errorSlice";
import loaderReducer from "@/features/loader/loaderSlice";
import quotesReducer from "@/features/quote/quoteSlice";
import metadataSlice from "@/features/metadata/metadataSlice";
import storage from "./storage";
import tokenSlice from "@/features/token/tokenSlice";
import proposalSlice from "@/features/proposalDetails/proposalSlice";

const persistConfig = {
  key: "root",
  storage: storage,
};
const appReducer = combineReducers({
  counter: counterReducer,
  quotes: quotesReducer,
  error: errorReducer,
  loader: loaderReducer,
  metadata: metadataSlice,
  token: tokenSlice,
  proposal: proposalSlice,
});

const rootReducer = (state, action) => {
  // Used to clear the persisted store data on a specific action.
  // Reference: https://bionicjulia.com/blog/clear-redux-toolkit-state-with-redux-persist-and-typescript
  if (action.type === "error/removeReduxData") {
    storage.removeItem("persis:root");
    state = {};
  }
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: ENVIRONMENT !== "production",
  middleware: [thunk],
});

export const persistor = persistStore(store);
